import styled from "styled-components";
import { FlexContainer, FlexDiv, FlexSection } from "@/components/Atoms/Box";
import Image from "@/components/Atoms/Image";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import Typography from "@/foundation/Typography/V2";

export const Wrapper = styled(FlexSection)`
  padding: 80px 0;
  background-image: ${({ theme }) => theme.colorsV2.shyft.gradient_main};
  position: relative;
  @media only screen and (max-width: 1079px) {
    padding: 56px 0;
  }
`;
export const Container = styled(FlexContainer)`
  flex-direction: column;
`;
export const TopBox = styled(FlexDiv)`
  flex-direction: column;
  padding: 0 24px;
  @media only screen and (max-width: 1079px) {
    padding: 0 16px;
  }
`;
export const LogoWrapper = styled(FlexDiv)`
  margin-bottom: 24px;
`;
export const LogoLink = styled(Typography)``;
export const Logo = styled(StyledSvgSprite)`
  fill: ${({ theme }) => theme.colors.white};
`;
export const Title = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.primary.shade_50};
`;
export const ImageHolder = styled(Image)``;
export const FeatureBox = styled(FlexDiv)`
  margin: 56px -26px 0;
`;
export const FeatureItem = styled(FlexDiv)`
  max-width: calc(16.6667% - 52px);
  width: 100%;
  margin: 0 26px;
  flex-direction: column;
  user-select: none;
`;
export const ImageDiv = styled(FlexDiv)`
  width: 48px;
  height: 48px;
  ${ImageHolder} {
    height: 100%;
    width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
`;
export const Counter = styled(Typography)``;
export const ImageBox = styled(FlexDiv)`
  margin-bottom: 8px;
  padding: 0 16px;
  position: relative;
  ${Counter} {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    width: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colorsV2.shyft.purple_text};
    border-radius: 50%;
    color: ${({ theme }) => theme.colors.white};
  }
`;
export const FeatureTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.white};
`;
